/** Platform-appropriate shortcut hints for the toolbar tooltips. */
export const IS_MAC = typeof navigator !== 'undefined' && /Mac|iP(hone|ad|od)/.test(navigator.userAgent);
